/**
 * Organizers section: organizers list.
 */

import { type ReactNode } from "react";
import { SmartSection } from "../SmartSection.tsx";
import { OrganizersList } from "../OrganizersList.tsx";
import type { EventOrganizer } from "../../types.ts";

export interface OrganizersSectionProps {
  id: string;
  eventId: string;
  organizers: EventOrganizer[];
  onUpdate: () => void;
  icon: ReactNode;
  summary: string;
  filledCount: number;
  totalCount: number;
  hint?: string;
}

export function OrganizersSection({
  id,
  eventId,
  organizers,
  onUpdate,
  icon,
  summary,
  filledCount,
  totalCount,
  hint,
}: OrganizersSectionProps) {
  return (
    <SmartSection
      id={id}
      title="Организаторы"
      icon={icon}
      summary={summary}
      filledCount={filledCount}
      totalCount={totalCount}
      hint={hint}
      defaultOpen={false}
    >
      <OrganizersList
        eventId={eventId}
        organizers={organizers}
        onUpdate={onUpdate}
      />
    </SmartSection>
  );
}
